import { AppProps } from 'presentation/App';
import { Route, Routes } from 'react-router-dom';
import ErrorSite from '../components/Error';
import LoadingComponent from '../components/Loading';
import { ModalContainerComponent } from '../components/Modal/ModalContainer.component';
import NotFound from '../components/NotFound';
import { PrivateRoute } from '../components/PrivateRoute';
import Page from '../pages';
import CU00100Page from '../pages/CU/CU-001-00';
import CU00101Page from '../pages/CU/CU-001-01';
import CU00102Page from '../pages/CU/CU-001-02';
import CU00104Page from '../pages/CU/CU-001-04';
import CU00105Page from '../pages/CU/CU-001-05';
import CU00201Page from '../pages/CU/CU-002-01';
import CU00202Page from '../pages/CU/CU-002-02';
import CU00203Page from '../pages/CU/CU-002-03';
import CU00301Page from '../pages/CU/CU-003-01';
import CU00302Page from '../pages/CU/CU-003-02';
import CU00400Page from '../pages/CU/CU-004-00';
import CU00401Page from '../pages/CU/CU-004-01';
import CU0050101Page from '../pages/CU/CU-005-01';
import CU0050102Page from '../pages/CU/CU-005-02';
import CU00601Page from '../pages/CU/CU-006-01';
import CU00701Page from '../pages/CU/CU-007-01';
import CU00703Page from '../pages/CU/CU-007-03';
import CU00901Page from '../pages/CU/CU-009-01';
import CU01001Page from '../pages/CU/CU-010-01';
import CU01002Page from '../pages/CU/CU-010-02';
import CU01101Page from '../pages/CU/CU-011-01';
import CU01201Page from '../pages/CU/CU-012-01';
import CU01202Page from '../pages/CU/CU-012-02';
import CU01301Page from '../pages/CU/CU-013-01';
import CU01402Page from '../pages/CU/CU-014-02';
import CU01501Page from '../pages/CU/CU-015-01';
import CU01502Page from '../pages/CU/CU-015-02';
import CU01601Page from '../pages/CU/CU-016-01';
import CU01602Page from '../pages/CU/CU-016-02';
import CU01702Page from '../pages/CU/CU-017-02';
import CU02001Page from '../pages/CU/CU-020-01';
import CU02101Page from '../pages/CU/CU-021-01';
import CU02102Page from '../pages/CU/CU-021-02';
import CU02103Page from '../pages/CU/CU-021-03';
import CU02201Page from '../pages/CU/CU-022-01';
import CU02501Page from '../pages/CU/CU-025-01';
import CU02601Page from '../pages/CU/CU-026-01';
import CU02701Page from '../pages/CU/CU-027-01';
import CU02801Page from '../pages/CU/CU-028-01';
import CU02901Page from '../pages/CU/CU-029-01';
import CU02902Page from '../pages/CU/CU-029-02';
import CU03001Page from '../pages/CU/CU-030-01';
import CU03101Page from '../pages/CU/CU-031-01';
import CU03301Page from '../pages/CU/CU-033-01';
import CU03501Page from '../pages/CU/CU-035-01';
import CU03601Page from '../pages/CU/CU-036-01';
import CU03602Page from '../pages/CU/CU-036-02';
import { CU004301Page } from '../pages/CU/CU-043-01';
import CU04801Page from '../pages/CU/CU-048-01';
import CU04901Page from '../pages/CU/CU-049-01';
import CU04902Page from '../pages/CU/CU-049-02';
import CU05001Page from '../pages/CU/CU-050-01';
import CU05101Page from '../pages/CU/CU-051-01';
import CU05102Page from '../pages/CU/CU-051-02';
import CU05201Page from '../pages/CU/CU-052-01';
import CU05202Page from '../pages/CU/CU-052-02';
import CU05301Page from '../pages/CU/CU-053-01';
import CU05302Page from '../pages/CU/CU-053-02';
import CU05401Page from '../pages/CU/CU-054-01';
import CU05501Page from '../pages/CU/CU-055-01';
import CU05502Page from '../pages/CU/CU-055-02';
import CU05503Page from '../pages/CU/CU-055-03';
import CU05504Page from '../pages/CU/CU-055-04';
import CU05505Page from '../pages/CU/CU-055-05';
import CU05601Page from '../pages/CU/CU-056-01';
import CU05601PageV2 from '../pages/CU-v2/CU-056-01';
import CU05602Page from '../pages/CU/CU-056-02';
import CU05602PageV2 from '../pages/CU-v2/CU-056-02';
import CU05603Page from '../pages/CU/CU-056-03';
import CU05603PageV2 from '../pages/CU-v2/CU-056-03';
import CU05701Page from '../pages/CU/CU-057-01';
import CU05801Page from '../pages/CU/CU-058-01';
import CU05802Page from '../pages/CU/CU-058-02';
import CU05901Page from '../pages/CU/CU-059-01';
import CU05902Page from '../pages/CU/CU-059-02';
import CU05903Page from '../pages/CU/CU-059-03';
import { CU0601Page } from '../pages/CU/CU-060-01/index';
import { CU06101Page } from '../pages/CU/CU-061-01';
import { CU06201Page } from '../pages/CU/CU-062-01';
import { CU06202Page } from '../pages/CU/CU-062-02';
import CU06301Page from '../pages/CU/CU-063-01';
import CU06501Page from '../pages/CU/CU-065-01';
import IconsPage from '../pages/templates/icons';
import { AUTH_ROUTES, PRIVATE_ROUTES, TEMPLATE_ROUTES } from './CONSTANTS';
import { VersionedPage } from './VersionedPage';

const Router = (props: AppProps) => {
    const privateRoutes: any[] = [
        {
            path: PRIVATE_ROUTES.SUB.CU_002_02 + '/:defaultValue?',
            element: <CU00202Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_002_03 + '/:listedPropertyId/:propertyId?/:auctionId?',
            element: <CU00203Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_050_01,
            element: <CU05001Page userUseCase={props.userUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_013_01 + '/:listedPropertyId',
            element: <CU01301Page auctionBidsUseCase={props.auctionBidsUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_015_01,
            element: <CU01501Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_015_02,
            element: <CU01502Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_016_01,
            element: <CU01601Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_016_02,
            element: <CU01602Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_022_01,
            element: <CU02201Page notifyUseCase={props.notifyUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_025_01,
            element: <CU02501Page authUseCase={props.authUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_028_01,
            element: <CU02801Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_029_01,
            element: <CU02901Page propertyUseCase={props.propertyUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_049_01,
            element: <CU04901Page propertyUseCase={props.propertyUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_029_02,
            element: <CU02902Page propertyUseCase={props.propertyUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_030_01 + '/:propertyId',
            element: (
                <CU03001Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_058_01 + '/:listedPropertyId',
            element: (
                <CU05801Page
                    simulateUseCase={props.simulateUseCase}
                    propertyUseCase={props.propertyUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_058_02 + '/:simId?',
            element: <CU05802Page simualteUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_061_01 + '/:settlementId',
            element: <CU06101Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_062_01 + '/:settlementId',
            element: <CU06201Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_062_02 + '/:settlementId',
            element: <CU06202Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_060_01 + '/:settlementId/:dealId',
            element: <CU0601Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_063_01 + '/:listedPropertyId',
            element: <CU06301Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_031_01 + '/:propertyId/:registeredId/:step?/:field?',
            element: (
                <CU03101Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_035_01 + '/:propertyId/:registeredId',
            element: (
                <CU03501Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                    userUseCase={props.userUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_033_01 + '/:propertyId/:registeredId',
            element: (
                <CU03301Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_036_01 + '/:propertyId/:registeredId/:auctionId?',
            element: (
                <CU03601Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_036_01 + '/:propertyId',
            element: (
                <CU03601Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_036_02 + '/:propertyId/:registeredId',
            element: (
                <CU03602Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                    assessmentUseCase={props.assessmentUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_002_01,
            element: (
                <CU00201Page
                    propertyUseCase={props.propertyUseCase}
                    masterUseCase={props.masterUseCase}
                    userUseCase={props.userUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_009_01 + '/:listedPropertyId',
            element: <CU00901Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_014_02 + '/:auctionId',
            element: <CU01402Page auctionBidsUseCase={props.auctionBidsUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_010_01,
            element: <CU01001Page simualteUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_010_02 + '/:simId?',
            element: <CU01002Page simulateUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_055_01,
            element: <CU05501Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_049_02 + '/:ListedPropertyId',
            element: <CU04902Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_051_01 + '/:listedPropertyId?',
            element: (
                <CU05101Page
                    simualteUseCase={props.simulateUseCase}
                    propertyUseCase={props.propertyUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_051_02 + '/:simId?',
            element: <CU05102Page simualteUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_052_01,
            element: <CU05201Page simualteUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_052_02 + '/:simId?',
            element: <CU05202Page simualteUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_054_01,
            element: <CU05401Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_055_01,
            element: <CU05501Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_055_02,
            element: <CU05502Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_055_03,
            element: <CU05503Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_055_04,
            element: <CU05504Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_055_05,
            element: <CU05505Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_053_01,
            element: <CU05301Page simualteUseCase={props.simulateUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_053_02 + '/:simId?',
            element: (
                <CU05302Page
                    simualteUseCase={props.simulateUseCase}
                    masterUseCase={props.masterUseCase}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_057_01,
            element: <CU05701Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_059_01,
            element: <CU05901Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_059_02 + '/:id1/:id2',
            element: <CU05902Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_059_03 + '/:id',
            element: <CU05903Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_017_01 + '/:listedPropertyId',
            element: <CU01702Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_043_01 + '/:settlementId',
            element: <CU004301Page fileUseCase={props.fileUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_004_00,
            element: <CU00400Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_004_01,
            element: <CU00401Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_006_01,
            element: <CU00601Page />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_007_01,
            element: <CU00701Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_007_03,
            element: <CU00703Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_003_01,
            element: <CU00301Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_011_01,
            element: <CU01101Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_003_02,
            element: <CU00302Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_020_01,
            element: <CU02001Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_021_01,
            element: <CU02101Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_021_02,
            element: <CU02102Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_021_03,
            element: <CU02103Page masterUseCase={props.masterUseCase} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_005_01,
            element: <CU0050101Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_005_02,
            element: <CU0050102Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_012_01,
            element: <CU01201Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_056_01,
            element: <VersionedPage pageId="CU_056_01" v1={CU05601Page} v2={CU05601PageV2} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_056_02,
            element: (
                <VersionedPage<AppProps>
                    pageId="CU_056_02"
                    v1={CU05602Page}
                    v2={CU05602PageV2}
                    pageProps={props}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_056_03,
            element: (
                <VersionedPage<AppProps>
                    pageId="CU_056_03"
                    v1={CU05603Page}
                    v2={CU05603PageV2}
                    pageProps={props}
                />
            ),
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_012_02,
            element: <CU01202Page {...props} />,
        },
        {
            path: PRIVATE_ROUTES.SUB.CU_065_01,
            element: (
                <CU06501Page userUseCase={props.userUseCase} notifyUseCase={props.notifyUseCase} />
            ),
        },
    ];

    const authRoutes: any[] = [
        {
            path: AUTH_ROUTES.SUB.CU_048_01,
            element: <CU04801Page />,
        },
        {
            path: AUTH_ROUTES.SUB.CU_001_00,
            element: <CU00100Page />,
        },
        {
            path: AUTH_ROUTES.SUB.CU_001_01,
            element: (
                <CU00101Page
                    authUseCase={props.authUseCase}
                    userStorage={props.userStorageUseCase}
                />
            ),
        },
        {
            path: AUTH_ROUTES.SUB.CU_001_02,
            element: (
                <CU00102Page
                    authUseCase={props.authUseCase}
                    userStorage={props.userStorageUseCase}
                />
            ),
        },
        {
            path: AUTH_ROUTES.SUB.CU_001_04,
            element: (
                <CU00104Page
                    authUseCase={props.authUseCase}
                    userStorage={props.userStorageUseCase}
                />
            ),
        },
        {
            path: AUTH_ROUTES.SUB.CU_001_05,
            element: (
                <CU00105Page
                    authUseCase={props.authUseCase}
                    userStorage={props.userStorageUseCase}
                />
            ),
        },
        {
            path: AUTH_ROUTES.SUB.CU_026_01,
            element: (
                <CU02601Page
                    authUseCase={props.authUseCase}
                    userStorage={props.userStorageUseCase}
                />
            ),
        },
        {
            path: AUTH_ROUTES.SUB.CU_027_01,
            element: <CU02701Page authUseCase={props.authUseCase} />,
        },
    ];
    const templateRoutes: any[] = [
        {
            path: TEMPLATE_ROUTES.SUB.ICONS,
            element: <IconsPage />,
        },
    ];

    return (
        <LoadingComponent>
            <ModalContainerComponent />
            <Routes>
                <Route
                    path="/"
                    errorElement={<ErrorSite />}
                    element={<Page userStorageUseCase={props.userStorageUseCase} />}
                />
                <Route path={AUTH_ROUTES.PATH}>
                    {authRoutes.map((element, index) => (
                        <Route
                            key={index}
                            path={element.path}
                            errorElement={<ErrorSite />}
                            element={element.element}
                        />
                    ))}
                </Route>
                <Route path={TEMPLATE_ROUTES.PATH}>
                    {templateRoutes.map((element, index) => (
                        <Route
                            key={index}
                            path={element.path}
                            errorElement={<ErrorSite />}
                            element={element.element}
                        />
                    ))}
                </Route>
                <Route
                    path={PRIVATE_ROUTES.PATH}
                    element={
                        <PrivateRoute
                            userStorageUseCase={props.userStorageUseCase}
                            authUseCase={props.authUseCase}
                            userUseCase={props.userUseCase}
                            chatUseCase={props.chatUseCase}
                            notifyUseCase={props.notifyUseCase}
                        />
                    }
                >
                    {privateRoutes.map((element, index) => (
                        <Route
                            key={index}
                            path={element.path}
                            errorElement={<ErrorSite />}
                            element={element.element}
                        />
                    ))}
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </LoadingComponent>
    );
};

export default Router;
